<template>
		<!-- This is the underlying Email List COMPONENT referenced by BWOF and by Trial Evac modules -->

		<!-- Filtering -->
		<div class="grid ml-0 mr-1">
			<div class="flex flex-auto p-input-icon-left p-input-icon-right mb-2">
				<i class="pi pi-home" />
				<InputText v-model="filterText" placeholder="Email keyword filter.." />
				<i class="pi pi-search" />
			</div>
		</div>

		<TabView v-model:activeIndex="activeTab" @tab-change="onTabChange">
			<!--Recommended Emails-->
			<TabPanel>
				<template #header>
					<i class="pi pi-envelope"></i>&nbsp;
					<span>Email Automation</span>
				</template>
				<div>

					<DataView :value="filteredEmailList"
							  datakey="propertyId"
							  :paginator="true"
							  :rows="50"
							  :scrollable="true"
							  stripedRows
							  class="p-datatable-sm property-service-table"
							  :paginatorTemplate="paginatorTemplate"
							  :rowsPerPageOptions="[10,20,50,100,200]"
							  responsiveLayout="scroll"
							  :alwaysShowPaginator="false"
							  @page="onPageChange"
							  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">

						<!--DataView header-->
						<template #header>

							<div class="col-12 grid flex-nowrap">
								<div class="col-fixed" style="margin-left:-1.5rem;">
									<Checkbox v-model="selectAllCheckbox" :binary="true" v-tooltip.top="'Select all records on the current page'"></Checkbox>
								</div>
								<div class="col-2">Property</div>
								<div class="col-2">Customer</div>
								<div class="col-2">Recipient Company</div>
								<div class="col-1 text-center">{{dueDateColumnHeader}}</div>
								<div class="col-1">Template Type</div>
								<div class="col-4"><div class="ml-6">Recipients</div></div>
							</div>

						</template>

						<!--DataView body-->
						<template #list="{data}">
							<div class="col-12 grid flex-nowrap">
								<div class="col-fixed">
									<Checkbox v-model="data.isSelectedOnRecommended" :binary="true"></Checkbox>
								</div>
								<div class="col-2">
									<router-link :to="{ name: 'PropertyDetails', params: { propertyId: data.propertyId }}">
										{{data.propertyId}} - {{data.propertyName}}
									</router-link>
								</div>
								<div class="col-2">
									<router-link :to="{ name: 'CompanyDetails', params: { companyId: data.customerCompanyId }}" v-if="data.customerCompanyId">
										<span v-if="data.customerCompanyName">{{data.customerCompanyName}}</span>
										<span v-else>ID: {{data.customerCompanyId}}</span>
									</router-link>
									<span v-else>Unknown</span>
								</div>
								<div class="col-2">
									<template v-if="data.recipientCompanyId">
										<router-link :to="{ name: 'CompanyDetails', params: { companyId: data.recipientCompanyId }}">
											<span v-if="data.recipientCompanyName">{{data.recipientCompanyName}}</span>
											<span v-else>ID: {{data.recipientCompanyId}}</span>
										</router-link>
										<a class="ml-1" @click="onEnvelopeClick(data)" v-tooltip.top="'Review Email'">
											<i class="pi pi-envelope" />
										</a>
									</template>
									<span v-else>Unknown</span>
								</div>
								<div class="col-1">
									{{formattedDate(data.nextDue)}}
								</div>
								<div class="col-1" v-bind:class="getStyleForTemplateName(data.emailContentTemplateName)">
									{{getEmailTemplateTypeFriendlyName(data.emailContentTemplateName)}}
								</div>
								<div class="col-4">
									<div class="pl-4 pr-4 text-wrap">
										{{getFormattedRecipients(data.recipients)}}
										<template v-if="data.ccRecipients">
											<br />
											CC: {{getFormattedRecipients(data.ccRecipients)}}
										</template>
									</div>
								</div>
							</div>
						</template>
					</DataView>
				</div>
			</TabPanel>

			<!--Sent Emails-->
			<TabPanel>
				<template #header>
					<i class="pi pi-send"></i>&nbsp;
					<span>Sent</span>
				</template>
				<div>
					<DataView :value="filteredEmailList"
							  datakey="propertyId"
							  :paginator="true"
							  :rows="50"
							  :scrollable="true"
							  stripedRows
							  class="p-datatable-sm property-service-table"
							  :paginatorTemplate="paginatorTemplate"
							  :rowsPerPageOptions="[10,20,50,100,200]"
							  responsiveLayout="scroll"
							  :alwaysShowPaginator="false"
							  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">

						<!--DataView header-->
						<template #header>

							<div class="col-12 grid flex-nowrap">
								<!--<div class="col-fixed email-select"></div>-->
								<div class="col-2">Property</div>
								<div class="col-2">Customer</div>
								<div class="col-2">Recipient Company</div>
								<div class="col-1">Status</div>
								<div class="col-1">Generated By</div>
								<div class="col-1">Template Type</div>
								<div class="col-1">When Last Attempted</div>
								<div class="col-2"><div class="ml-5">Recipients</div></div>
							</div>

						</template>

						<!--DataView body-->
						<template #list="{data}">
							<div class="col-12 grid flex-nowrap">
								<div class="col-2">
									<router-link :to="{ name: 'PropertyDetails', params: { propertyId: data.propertyId }}">
										{{data.propertyId}} - {{data.propertyName}}
									</router-link>
								</div>
								<div class="col-2">
									<router-link :to="{ name: 'CompanyDetails', params: { companyId: data.customerCompanyId }}" v-if="data.customerCompanyId">
										<span v-if="data.customerCompanyName">{{data.customerCompanyName}}</span>
										<span v-else>ID: {{data.customerCompanyId}}</span>
									</router-link>
									<span v-else>Unknown</span>
								</div>
								<div class="col-2">
									<router-link :to="{ name: 'CompanyDetails', params: { companyId: data.recipientCompanyId }}" v-if="data.recipientCompanyId">
										<span v-if="data.recipientCompanyName">{{data.recipientCompanyName}}</span>
										<span v-else>ID: {{data.recipientCompanyId}}</span>
									</router-link>
									<span v-else>Unknown</span>
								</div>
								<div class="col-1">
									<span v-tooltip.top="'Triggered on: ' + formattedDateTime(data.lstSupEmailTrg)" v-if="isQueued(data.status)">{{data.status}}</span>
									<span v-tooltip.top="'Last Attempted: ' + formattedDateTime(data.lstSupEmailSent)" v-else>{{data.status}}</span>
								</div>
								<div class="col-1 text-wrap">
									<span v-if="data.generatedBy">{{data.generatedBy}}</span>
									<span v-else-if="isQueued(data.status)">-</span>
									<span v-else>Unknown</span>
								</div>
								<div class="col-1" v-bind:class="getStyleForTemplateName(data.emailContentTemplateName)">
									{{getEmailTemplateTypeFriendlyName(data.emailContentTemplateName)}}
								</div>
								<div class="col-1">
									<span v-tooltip.top="'Last Attempted: ' + formattedDateTime(data.lstSupEmailSent)" v-if="data.lstSupEmailSent">{{formattedDate(data.lstSupEmailSent)}}</span>
									<span v-else>Never</span>
								</div>
								<div class="col-2">
									<div class="text-wrap">
										{{getFormattedRecipients(data.recipients)}}
										<template v-if="data.ccRecipients">
											<br />
											CC: {{getFormattedRecipients(data.ccRecipients)}}
										</template>
									</div>
								</div>
							</div>
						</template>
					</DataView>
				</div>
			</TabPanel>

			<!--Snoozed Emails-->
			<TabPanel>
				<template #header>
					<i class="pi pi-pause"></i>&nbsp;
					<span>Snoozed / Held</span>
				</template>
				<div>
					<DataView :value="filteredEmailList"
							  datakey="propertyId"
							  :paginator="true"
							  :rows="50"
							  :scrollable="true"
							  stripedRows
							  class="p-datatable-sm property-service-table"
							  :paginatorTemplate="paginatorTemplate"
							  :rowsPerPageOptions="[10,20,50,100,200]"
							  responsiveLayout="scroll"
							  :alwaysShowPaginator="false"
							  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">

						<!--DataView header-->
						<template #header>

							<div class="col-12 grid flex-nowrap">
								<div class="col-fixed email-select"></div>
								<div class="col-2">Property</div>
								<div class="col-2">Customer</div>
								<div class="col-2">Recipient Company</div>
								<div class="col-1 text-center">{{dueDateColumnHeader}}</div>
								<div class="col-1">Template Type</div>
								<div class="col-fixed email-last-sent-header">When Last Sent</div>
								<div class="col-1"><div class="ml-5">Reason</div></div>
								<div class="col-fixed email-recipients"><div class="ml-5">Recipients</div></div>
							</div>

						</template>

						<!--DataView body-->
						<template #list="{data}">
							<div class="col-12 grid flex-nowrap">
								<!--Only allow selection for emails that are Snoozed-->
								<div class="col-fixed email-select">
									<Checkbox v-model="data.isSelectedOnSnoozed" :binary="true" v-if="isOnlySnoozed(data.reason)" />
									<Checkbox v-model="data.isSelectedOnSnoozed" :binary="true"
											  :disabled="true"
											  v-tooltip.top="'You can only resume emails that were snoozed'"
											  v-else />
								</div>
								<div class="col-2">
									<router-link :to="{ name: 'PropertyDetails', params: { propertyId: data.propertyId }}">
										{{data.propertyId}} - {{data.propertyName}}
									</router-link>
								</div>
								<div class="col-2">
									<router-link :to="{ name: 'CompanyDetails', params: { companyId: data.customerCompanyId }}" v-if="data.customerCompanyId">
										<span v-if="data.customerCompanyName">{{data.customerCompanyName}}</span>
										<span v-else>ID: {{data.customerCompanyId}}</span>
									</router-link>
									<span v-else>Unknown</span>
								</div>
								<div class="col-2">
									<router-link :to="{ name: 'CompanyDetails', params: { companyId: data.recipientCompanyId }}" v-if="data.recipientCompanyId">
										<span v-if="data.recipientCompanyName">{{data.recipientCompanyName}}</span>
										<span v-else>ID: {{data.recipientCompanyId}}</span>
									</router-link>
									<span v-else>Unknown</span>
								</div>
								<div class="col-1">
									{{formattedDate(data.nextDue)}}
								</div>
								<div class="col-1" v-bind:class="getStyleForTemplateName(data.emailContentTemplateName)">
									{{getEmailTemplateTypeFriendlyName(data.emailContentTemplateName)}}
								</div>
								<div class="col-fixed email-last-sent-header">
									<span v-if="data.lstSupEmailSent" v-tooltip.top="'Last Email Sent: ' +formattedDateTime(data.lstSupEmailSent)">{{formattedDate(data.lstSupEmailSent)}}</span>
									<span v-else>Never</span>
								</div>
								<div class="col-1">
									<span v-if="isSnoozed(data.reason)" v-tooltip.top="'Snoozed until: ' + formattedDateTime(data.snoozedTill)">{{data.reason}}</span>
									<span v-else>{{data.reason}}</span>
								</div>
								<div class="col-2">
									<div class="text-wrap">
										{{data.recipients}}
										<template v-if="data.ccRecipients">
											<br />
											CC: {{getFormattedRecipients(data.ccRecipients)}}
										</template>
									</div>
								</div>
							</div>
						</template>
					</DataView>
				</div>
			</TabPanel>
		</TabView>

	<!--Controls / Buttons-->
	<template v-if="!loading">

		<!-- Buttons for Recommended Emails tab -->
		<template v-if="activeTab == 0">
			<Button class="sticky-button btn-fixed-width" icon="pi pi-send" label="Send" @click="sendEmailsConfirmation" :disabled="selectedOnRecommendedEmailCount == 0 || isBulkSendingDisabled " :class="isBulkSendingDisabled ? 'disabled-feature':''" />
			<SplitButton ref="snoozeButton" :model="snoozeOptions" class="sticky-button btn-fixed-width" icon="pi pi-pause" label="Snooze" @click="snoozeEmailsConfirmation(7)" :disabled="selectedOnRecommendedEmailCount == 0" />
		</template>

		<!-- Buttons for Sent Emails tab -->
		<template v-if="activeTab == 1">
			<Button class="sticky-button btn-fixed-width" icon="pi pi-forward" label="Trigger Email Automation" @click="triggerEmailSend" :disabled="getQueuedEmails.length == 0 || !triggerEmailAutomationEnabled || isBulkSendingDisabled" :class="isBulkSendingDisabled ? 'disabled-feature':''" />
		</template>

		<!-- Buttons for Snoozed Emails tab -->
		<template v-if="activeTab == 2">
			<Button class="sticky-button btn-fixed-width" icon="pi pi-play" label="Resume" @click="resumeEmailsConfirmation" :disabled="selectedOnSnoozedEmailCount == 0" />
			<Button class="sticky-button btn-fixed-width" icon="pi pi-send" label="Resume & Send" @click="resumeAndSendEmailsConfirmation" :disabled="selectedOnSnoozedEmailCount == 0 || isBulkSendingDisabled" :class="isBulkSendingDisabled ? 'disabled-feature':''" />
		</template>
	</template>

	<!--Document generation modal-->
	<DocumentGeneration :selectedDocumentTemplate="selectedDocumentTemplate"
						:selectedEmailTemplate="selectedEmailTemplate"
						:propertyData="propertyData"
						:toggledService="toggledService"
						:initialActiveTab="documentGenerationActiveTab"
						:isEmailSendingDisabled="false"
						:recipientCompanyId="envelopeClickRecipientCompanyId"
						@updateShowDocumentGenerationComponent="showDocumentGenerationComponent = $event;"
						@reloadData="loadEmailData"
						@refreshSentEmails="refreshSentEmails = $event"
						v-if="showDocumentGenerationComponent" />

	<ProgressSpinner v-if="loading" />
</template>

<script lang="ts">
	import { Vue, Options } from 'vue-class-component';
	import { AutomatedEmailData, PropertyData, EmailTemplateType, SendSnoozeEmailsRequest, PropertyServiceData, GetAutomationEmailResponseModel } from '../api-client/api-client';
	import { CompassApi } from '@/api-client/CompassApiProxy';
	import { format, isValid } from 'date-fns';
	import filterListBySearchString from '../utils/StringSearch';
	import { GetCompassCompanyID } from '@/utils/CompassConstants';
	import Toast from '@/utils/Toast';
	import { DataViewPageEvent } from 'primevue/dataview'
	import { ConfirmationOptions } from 'primevue/confirmationoptions';
	import DocumentGeneration from './DocumentGeneration.vue';

	interface EmailItem extends AutomatedEmailData {
		isSelectedOnRecommended: boolean;
		isSelectedOnSnoozed: boolean;
	}

	@Options({
		name: 'OutboundEmailList',
		components: {
		},
		props: {
			emailModuleType: String,
			dueDateColumnHeader: String,
		},
		watch: {
			selectAllCheckbox(_value: boolean) {
				this.selectAllOnPage();
			},
		},
	})

	export default class OutboundEmailList extends Vue {

		// Originally bulk sending was intended to be a future feature still disabled
		// as Compass prefers current workflow (checking emails before being sent)
		isBulkSendingDisabled = true;

		activeTab = 0;
		filterText = "";
		selectAllCheckbox = false;

		// Default paginaton 0 - 50
		indexFirstRecord = 0;
		indexLastRecord = 50;

		recommendedEmailList: AutomatedEmailData[] = [];
		sentEmailList: AutomatedEmailData[] = [];
		heldEmailList: AutomatedEmailData[] = [];

		loading = true;
		triggerEmailAutomationEnabled = true;

		toggledService: PropertyServiceData = new PropertyServiceData;
		propertyData: PropertyData = new PropertyData();
		selectedDocumentTemplate: string | null = null;
		selectedEmailTemplate: EmailTemplateType | null = null;
		showDocumentGenerationComponent = false;
		documentGenerationActiveTab = 0;
		compassCompanyID = GetCompassCompanyID();
		wasEmailSentManually = false;
		envelopeClickRecipientCompanyId: number = null!;

		emailModuleType: string = null!;

		isBwof: boolean = true;

		// Reload sent emails on load, or if email is sent
		refreshSentEmails = true;

		created() {
			this.isBwof = this.emailModuleType == 'bwof';
			this.loadEmailData();
		}

		loadEmailData() {
			// Set All Checkbox to false if reloading data
			this.selectAllCheckbox = false;
			this.loading = true;

			const apiClient = CompassApi.emailApi(this.$store);
			const apiCall = this.isBwof ? apiClient.get12aEmaiList() : apiClient.getTrialEvacuationEmailList();

			apiCall.then(result => {
				this.loading = false;

				if (this.isBwof && Array.isArray(result)) {
					this.recommendedEmailList = result.recommendedEmails || [];
					this.heldEmailList = result.heldEmails || [];
				} else {
					const singleResult = result as GetAutomationEmailResponseModel;
					this.recommendedEmailList = singleResult.recommendedEmails || [];
					this.sentEmailList = singleResult.sentEmails || [];
					this.heldEmailList = singleResult.heldEmails || [];
				}

				Toast.RemoveAllGroups();
			})
				.catch(error => {
					this.loading = false;
					Toast.ApiError('Error retrieving email data', error);
				});
		}

		fetchSentBwofEmails() {
			this.loading = true;
			this.selectAllCheckbox = false;
			this.loading = true;

			const apiClient = CompassApi.emailApi(this.$store);
			apiClient.get12aSentEmaiList()
				.then(sentEmails => {
					this.loading = false;
					this.sentEmailList = sentEmails || [];
					Toast.RemoveAllGroups();
					this.refreshSentEmails = false;
				})
				.catch(error => {
					this.loading = false;
					Toast.ApiError('Error retrieving sent emails', error);
				});
		}

		sendEmailsConfirmation() {

			this.$confirm.require({
				header: 'Send Emails',
				message: 'Are you sure you want to send the selected ' + this.selectedOnRecommendedEmailCount + ' email(s) ?',
				accept: () => {

					// PropertyService IDs to send the property service emails
					const propertyServiceIds: number[] = []

					// List of Property IDs to send the authority emails
					const authorityPropertyIdList: number[] = []

					this.recommendedEmailList.forEach((item) => {
						if (item.isSelectedOnRecommended != null && item.isSelectedOnRecommended == true) {

							if (item.subServices && item.subServices?.length > 0) {
								item.subServices.forEach((subService) => {
									if (subService.propertyServiceId)
										propertyServiceIds.push(subService.propertyServiceId);
								});
							}

							if (item.propertyId && item.emailContentTemplateName == EmailTemplateType.Email_AuthorityOverdueBwofNotification)
								authorityPropertyIdList.push(item.propertyId)
						}
					});

					this.sendEmails(propertyServiceIds, authorityPropertyIdList);
				},
				reject: () => {
					// do nothing
				}
			} as ConfirmationOptions);
		}

		sendEmails(propertyServiceIds: number[], authorityPropertyIdList: number[]) {
			const model = new SendSnoozeEmailsRequest();
			model.propertyServiceIdList = propertyServiceIds;
			model.authorityPropertyIdList = authorityPropertyIdList;

			const apiClient = CompassApi.emailApi(this.$store);
			apiClient.send12aEmails(model)
				.then(result => {
					// update the email lists
					this.recommendedEmailList = result.recommendedEmails ? result.recommendedEmails : this.recommendedEmailList;
					this.heldEmailList = result.heldEmails ? result.heldEmails : this.heldEmailList;

					// Only evac returns sent emails in response. Bwof loads sent emails when tab is clicked
					if (!this.isBwof) {
						this.sentEmailList = result.sentEmails ? result.sentEmails : this.sentEmailList;
					}

					// If checkbox was selected, then set to false
					this.selectAllCheckbox = false;

					Toast.RemoveAllGroups();
					this.refreshSentEmails = false;
				})
				.catch(error => {
					this.loading = false;
					Toast.ApiError('Error retrieving sent emails', error);
				});
		}

		snoozeEmailsConfirmation(numberOfDays: number) {

			this.$confirm.require({
				header: 'Snooze Emails',
				message: 'Are you sure you want to snooze the selected ' + this.selectedOnRecommendedEmailCount + ' email(s) for the next ' + numberOfDays + ' days ?',
				accept: () => {
					this.snoozeEmails(numberOfDays);
				},
				reject: () => {
					// do nothing
				}
			} as ConfirmationOptions);
		}

		snoozeEmails(numberOfDays: number) {

			// PropertyService IDs to snooze the property service emails
			const propertyServiceIds: number[] = []

			// List of Property IDs to snooze the authority emails
			const authorityPropertyIdList: number[] = [] 

			if (this.isBwof) {
				this.recommendedEmailList.forEach((item: AutomatedEmailData) => {
				if (item.isSelectedOnRecommended != null && item.isSelectedOnRecommended == true) {

					if (item.subServices && item.subServices?.length > 0) {
						item.subServices.forEach((subService) => {
							if (subService.propertyServiceId)
								propertyServiceIds.push(subService.propertyServiceId);
						});
					}

					if (item.propertyId && item.emailContentTemplateName == EmailTemplateType.Email_AuthorityOverdueBwofNotification)
						authorityPropertyIdList.push(item.propertyId)
				}
			});

			} else {

				// evac service only snoozes property services
				this.recommendedEmailList.forEach((item: AutomatedEmailData) => {
					if (item.isSelectedOnRecommended != null && item.isSelectedOnRecommended == true) {
						if (item.specificPropertyServiceID) {
							propertyServiceIds.push(item.specificPropertyServiceID);
						}
					}
				});
			}

			const snoozeEmailsRequest = new SendSnoozeEmailsRequest();
			snoozeEmailsRequest.numberOfDays = numberOfDays;
			snoozeEmailsRequest.propertyServiceIdList = propertyServiceIds;
			snoozeEmailsRequest.authorityPropertyIdList = authorityPropertyIdList;
			snoozeEmailsRequest.isBwofEmail = this.isBwof;

			const apiClient = CompassApi.emailApi(this.$store);

			apiClient.snoozeEmails(snoozeEmailsRequest)
				.then(result => {
					// update the email lists
					this.recommendedEmailList = result.recommendedEmails ? result.recommendedEmails : this.recommendedEmailList;
					this.heldEmailList = result.heldEmails ? result.heldEmails : this.heldEmailList;

					// Only evac returns sent emails in response. Bwof loads sent emails when tab is clicked
					if (!this.isBwof) {
						this.sentEmailList = result.sentEmails ? result.sentEmails : this.sentEmailList;
					}

					// If checkbox was selected, then set to false
					this.selectAllCheckbox = false;

					Toast.RemoveAllGroups();
				})
				.catch(error => {
					Toast.ApiError('Error retrieving recommended emails ', error);
				});
		}

		resumeEmailsConfirmation() {

			this.$confirm.require({
				header: 'Resume Emails',
				message: 'Are you sure you want to resume the selected ' + this.selectedOnSnoozedEmailCount + ' email(s)?',
				accept: () => {
					this.resumeEmails(false);
				},
				reject: () => {
					// do nothing
				}
			} as ConfirmationOptions);
		}

		resumeEmails(sendEmailsAlso = false) {

			// PropertyService IDs to resume the property service emails
			const propertyServiceIds: number[] = []

			// List of Property IDs to resume the authority emails
			const authorityPropertyIdList: number[] = []

			this.heldEmailList.forEach((item: AutomatedEmailData) => {
				if (item.isSelectedOnSnoozed != null && item.isSelectedOnSnoozed == true) {

					if (item.subServices && item.subServices?.length > 0) {
						item.subServices.forEach((subService) => {
							if (subService.propertyServiceId)
								propertyServiceIds.push(subService.propertyServiceId);
						});
					}

					if (item.propertyId && item.emailContentTemplateName == EmailTemplateType.Email_AuthorityOverdueBwofNotification)
						authorityPropertyIdList.push(item.propertyId)
				}
			});

			const model = new SendSnoozeEmailsRequest();
			model.propertyServiceIdList = propertyServiceIds;
			model.authorityPropertyIdList = authorityPropertyIdList;
			model.isBwofEmail = this.isBwof;

			const apiClient = CompassApi.emailApi(this.$store);
			apiClient.resumeEmails(model) 
				.then(result => {
					// update the emails lists
					this.recommendedEmailList = result.recommendedEmails ? result.recommendedEmails : this.recommendedEmailList;
					this.heldEmailList = result.heldEmails ? result.heldEmails : this.heldEmailList;

					if (!this.isBwof) {
						this.sentEmailList = result.sentEmails ? result.sentEmails : this.sentEmailList;
					}

					Toast.RemoveAllGroups();

					if (sendEmailsAlso == true) {
						this.sendEmails(propertyServiceIds, authorityPropertyIdList);
					}
				})
				.catch(error => {
					Toast.ApiError('Error retrieving recommended emails ', error);
				});
		}

		resumeAndSendEmailsConfirmation() {

			this.$confirm.require({
				header: 'Resume Emails',
				message: 'Are you sure you want to resume and send emails for the selected ' + this.selectedOnSnoozedEmailCount + ' email(s)?',
				accept: () => {
					this.resumeEmails(true);
				},
				reject: () => {
					// do nothing
				}
			} as ConfirmationOptions);
		}

		triggerEmailSend() {
			const apiClient = CompassApi.emailApi(this.$store);
			apiClient.trigger12aEmails()
				.then(() => {
					this.triggerEmailAutomationEnabled = false;

					Toast.RemoveAllGroups();
					Toast.Success('Email Automation', "Email sending automation task has been succesfully triggered.");
				})
				.catch(error => {
					Toast.ApiError('Error retrieving recommended emails ', error);
				});
		}

		selectAllOnPage() {

			if (this.selectAllCheckbox == true)
				this.filteredEmailList.forEach((item, index) => {
					if (index >= this.indexFirstRecord && index < this.indexLastRecord)
						(item as EmailItem).isSelectedOnRecommended = true;
				});
			else
				this.filteredEmailList.forEach((item) => {
					(item as EmailItem).isSelectedOnRecommended = false;
				});
		}

		onPageChange(e: DataViewPageEvent) {
			this.indexFirstRecord = e.first;
			this.indexLastRecord = e.first + e.rows;

			this.selectAllCheckbox = false;
		}

		isQueued(status: string) {
			if (status == null || status == '')
				return false;
			return status.toUpperCase().includes('QUEUED');
		}

		isSnoozed(reason: string | undefined) {
			if (reason)
				return reason.toUpperCase().includes('SNOOZED');

			return false;
		}

		isOnlySnoozed(reason: string | undefined) {
			if (reason)
				return reason.toUpperCase() == 'SNOOZED';

			return false;
		}

		getEmailTemplateTypeFriendlyName(templateName: EmailTemplateType): string {
			const friendlyName =
				("" + EmailTemplateType[templateName])
					.replaceAll("Email_", "")
					.replaceAll("TrialEvac_", "Evac_")
					.replaceAll("FullService", "Full Service")
					.replaceAll("AuthorityOverdueBwofNotification", "Overdue BWOF Advisory")
					.replaceAll("_", " ");

			return friendlyName;
		}

		getFormattedRecipients(recipients?: string) {
			let result = "";

			if (recipients != null)
				recipients.split(';').forEach(r => { result += r + '\n'; });

			return result;
		}

		getStyleForTemplateName(templateName: EmailTemplateType): string {
			const templateCss =
				("" + EmailTemplateType[templateName])
					.replaceAll("Email_12A_", "")
					.replaceAll("Email_TrialEvac_Audit", "")
					.replaceAll("Email_TrialEvac_FullService", "")
					.replaceAll("_", "")
					.toLowerCase();

			if (templateCss.includes("overduebwofnotification"))
				return "overduebwofnotification";

			if (templateCss.includes("followup"))
				return "followup";

			if (templateCss.includes("urgent"))
				return "urgent";

			if (templateCss.includes("overdue"))
				return "overdue";

			return "normal";
		}

		onEnvelopeClick(emailRow: AutomatedEmailData) {
			if (emailRow.propertyId) {
				// Retrieve full property data for this property id
				const apiClient = CompassApi.propertyApi(this.$store);
				apiClient.getPropertyById(emailRow.propertyId)
					.then(result => {
						// Set the propertyData
						this.propertyData = result;

						this.envelopeClickRecipientCompanyId = emailRow.recipientCompanyId ?? this.envelopeClickRecipientCompanyId;

						// map to services
						const subServices: PropertyServiceData[] = [];
						const autoEmailedSubServices = emailRow.subServices

						// EVAC & 12A
						if (autoEmailedSubServices && autoEmailedSubServices.length > 0) {

							for (const subservice of autoEmailedSubServices) {
								const subService = new PropertyServiceData({
									propertyServiceId: subservice.propertyServiceId,
									propertyId: subservice.propertyId,
									supplierCompanyId: subservice.supplierId,
									supplierName: subservice.subServiceSupplierName,
									serviceName: subservice.serviceName,
									whenLastComplianceReceived: subservice.lstSubSrvCompRec,
									whenNextServiceAnniversary: subservice.nextSubSrvAniv,
									exceptionNotes: subservice.exceptionNotes,
									whenLastSupplierEmailSent: subservice.lstSupEmailSent,
									whenLastSupplierEmailTriggered: subservice.lstSupEmailTrg,
									whenSupplierEmailsSnoozedUntil: subservice.snoozedTill
								});
								subServices.push(subService);
							}

						// BWOF
						} else {
							const subService = new PropertyServiceData({
								propertyServiceId: emailRow.specificPropertyServiceID,
								propertyId: emailRow.propertyId,
								supplierCompanyId: emailRow.customerCompanyId,
								supplierName: emailRow.customerCompanyName,
								propertyName: emailRow.propertyName,
								exceptionNotes: undefined,
								whenLastComplianceReceived: undefined,
								whenNextServiceAnniversary: undefined,
								whenLastSupplierEmailTriggered: emailRow.lstSupEmailTrg,
								whenLastSupplierEmailSent: emailRow.lstSupEmailSent,
								whenSupplierEmailsSnoozedUntil: emailRow.snoozedTill,
							});
							subServices.push(subService);
						}

						// multiple services are returned from getPropertyById API
						this.toggledService = subServices[0];
	
						// Set the document template
						this.selectedEmailTemplate = emailRow.emailContentTemplateName as EmailTemplateType;
						const exists = this.selectedEmailTemplate in EmailTemplateType;
						if (!exists) {
							Toast.Error("Unknown email template type " + this.selectedEmailTemplate, "");
							return;
						}

						// 12 A Request emails have an attached file
						if (EmailTemplateType[this.selectedEmailTemplate].indexOf("12A") > 0) {
							if (this.toggledService.supplierCompanyId == this.compassCompanyID)
								this.selectedDocumentTemplate = "CertificateOfComplianceTemplate";
							else
								this.selectedDocumentTemplate = "CertificateOfComplianceTemplateExternal";

							// Go directly to the email tab
							this.documentGenerationActiveTab = 1;
						}
						else {
							// Authority overdue doesn't have a generated file
							this.selectedDocumentTemplate = null;
							this.documentGenerationActiveTab = 0;
						}

						// Trigger the popup
						this.showDocumentGenerationComponent = true;
					})
					.catch(error => {
						Toast.ApiError('Error loading property data for property ' + emailRow.propertyId, error);
						this.loading = false;
					});
			}
		}

		onTabChange()
		{
			// Reload sent emails if bwof and sent emails tab is opened and user sent an email/onload
			if (this.isBwof && this.activeTab === 1 && this.refreshSentEmails)
				this.fetchSentBwofEmails();
		}

		get getQueuedEmails() {
			return this.sentEmailList.filter(s => s.status?.toUpperCase() == "QUEUED");
		}

		get getFirstIndex() {
			return this.indexFirstRecord;
		}

		get getLastIndex() {
			return this.indexLastRecord;
		}

		get snoozeOptions() {
			return [
				{
					label: '7 days',
					command: () => {
						this.snoozeEmailsConfirmation(7);
					}
				},
				{
					label: '14 days',
					command: () => {
						this.snoozeEmailsConfirmation(14);
					}
				},
				{
					label: '30 days',
					command: () => {
						this.snoozeEmailsConfirmation(30);
					}
				},
				{
					label: '90 days',
					command: () => {
						this.snoozeEmailsConfirmation(90);
					}
				},
			];
		}

		get selectedOnRecommendedEmailCount() {
			return this.recommendedEmailList.filter(item => (item as EmailItem).isSelectedOnRecommended && (item as EmailItem).isSelectedOnRecommended == true).length;
		}

		get selectedOnSnoozedEmailCount() {
			return this.heldEmailList.filter(item => (item as EmailItem).isSelectedOnSnoozed && (item as EmailItem).isSelectedOnSnoozed == true).length;
		}

		// Filtering
		get filteredEmailList() {
			let list = this.recommendedEmailList
			if (this.activeTab == 1)
				list = this.sentEmailList;

			if (this.activeTab == 2)
				list = this.heldEmailList;


			list = filterListBySearchString(list, this.filterText, (emailData: AutomatedEmailData) =>
				emailData.propertyId
				+ ' ' + emailData.propertyName
				+ ' ' + emailData.recipientCompanyName
				+ ' ' + emailData.customerCompanyName
				+ ' ' + emailData.recipients
				+ ' ' + emailData.ccRecipients
				+ ' ' + emailData.status
				+ ' ' + emailData.generatedBy
				+ ' ' + emailData.reason
				+ ' ' + (emailData.emailContentTemplateName ? this.getEmailTemplateTypeFriendlyName((emailData.emailContentTemplateName)) : ""));
			return list;
		}

		get propertyListError() {
			return this.$store.state.propertyList.errorMessage;
		}

		// Format dates
		formattedDate(date: Date) {
			if (!isValid(date)) return;

			return format(date, 'dd MMM yyyy');
		}
		formattedDateTime(date: Date) {
			if (!isValid(date)) return;

			return format(date, 'dd MMM yyyy HH:mm');
		}
		// Computed isDesktop
		get isDesktop() {
			return window.innerWidth >= 992;
		}
		// Computed to simplify paginator on mobile
		get paginatorTemplate() {
			return this.isDesktop ?
				"CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
				: "PrevPageLink NextPageLink"
		}
	}
</script>

<style scoped lang="scss">
	.overdue {
		color: #EB0000; // reddish pink from original system
	}

	.overduebwofnotification {
		color: blue;
	}

	.urgent {
		color: #704D00; // orange from original system
	}

	.initial, .followup {
		color: #106515; // green from original system
	}

	.normal {

	}
</style>